import React from "react";
import { DestinationTypeEnum } from "../../../../../enums/destination";
import {
  AllDestinations,
  ShopifyDestination,
  WordPressDestination,
} from "../../../../../models";

export const DestinationURLColumn = ({
  destination,
}: {
  destination: AllDestinations;
}) => {
  let url: string;
  if (destination.destinationTypeId === DestinationTypeEnum.SHOPIFY) {
    const shopifyDestination = destination as ShopifyDestination;
    url = `https://${shopifyDestination.destination.storeName}.myshopify.com/`;
  } else {
    const wordpressDestination = destination as WordPressDestination;
    url = wordpressDestination.destination.url;
  }

  return (
    <div
      className="truncate overflow-hidden text-primary w-max"
      onClick={(e: any) => {
        e.stopPropagation();
        window.open(url, "_blank");
      }}
    >
      {url}
    </div>
  );
};
